import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  IEventCategoryStore,
} from '../../mobx-store/storeInterfaces/eventsCategoryInterface';

interface IProps extends WithSnackbarProps {
  eventCategoryStore: IEventCategoryStore;
  history: any;
}

@inject('eventCategoryStore')
@observer
class eventCategory extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title = 'Event Category Management';

  constructor(props: IProps) {
    super(props);
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/events/category/${this.props.eventCategoryStore.eventCategoryList[index].eventCategoryId}/edit`);
  };

  handleAdd = (): void => {
    this.props.history.push('/events/category/new');
  };

  getAddEventCategoryButton = () => ({
    title: 'Add',
    onAdd: this.handleAdd,
  });

  getEventCategoryTableHeader = () => [
    {
      title: 'Category Title',
    },
    {
      title: 'Edit',
    },
  ];

  getEventCategoryTableData = () => this.props.eventCategoryStore.eventCategoryList
    .map((eventCategory) => ({
      ...eventCategory, edit: 'Edit',
    }));

  getEventCategoryTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.addButton = this.getAddEventCategoryButton();
    this.tableHeader = this.getEventCategoryTableHeader();
    this.tableData = this.getEventCategoryTableData();
    this.tableCellTypes = this.getEventCategoryTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage="There are no event category yet. Please add a new now"
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.eventCategoryStore.getEventsCategoryRequestStatus
          ]}
        />
      </div>
    );
  }

  componentDidMount() {
    this.props.eventCategoryStore.getEventCategory();
  }
}

export default eventCategory;
